import React, {Component} from 'react';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import theme from "../data/controller.json";
import PrivacyPolicyDialog from "../dialogs/PrivacyPolicyDialog";

class ControllerInfo extends Component {

    state = {
        policyOpen: false,
    };

    togglePolicy = () => {
        this.setState({policyOpen: !this.state.policyOpen});
    };

    render() {
        return(
            <div>
                <List>
                    <Subheader>Logo:</Subheader>
                    <ListItem style={{textAlign: "center"}}><img src={theme.controller.logo} alt=""/></ListItem>
                    <Subheader>Name:</Subheader>
                    <ListItem primaryText={theme.controller.name}/>
                    <Subheader>Address:</Subheader>
                    <ListItem primaryText={<span>{theme.controller.address}</span>}/>
                    <Subheader>Email address:</Subheader>
                    <ListItem primaryText={<a href={theme.controller.email}>privacy@tu-berlin.de</a>}/>
                    <Subheader>Privacy policy:</Subheader>
                    <ListItem primaryText={<a onClick={this.togglePolicy}>Privacy policy</a>}/>
                    <Subheader>Review consent:</Subheader>
                    <ListItem primaryText={<a href="#consent">Review consent</a>}/>

                </List>
                <PrivacyPolicyDialog
                    policyOpen={this.state.policyOpen}
                    togglePolicy={this.togglePolicy}
                />
            </div>
        );
    }

}

export default ControllerInfo;


// WEBPACK FOOTER //
// ./src/sidebar/ControllerInfo.js